/* eslint-disable */
'use strict';
exports.__esModule = true;
exports.default = {
  "account": "Account",
  "active_date": "Active Date",
  "address": "Address",
  "address2": "Address 2 (Optional)",
  "amount": "Amount",
  "and": "and",
  "article": "Article",
  "buy": "Purchase",
  "buyer": "Buyer",
  "buyer_info": "Buyer Information",
  "cancel": "Cancel",
  "canceled": "Canceled",
  "cellphone": "Cell Phone",
  "certification_expires": "Unauthorized or expired, please sign in again.",
  "change_password": "Change Password",
  "city": "City",
  "clear": "Clear",
  "commercial": "Commercial",
  "company": "Company",
  "completed": "Completed",
  "confirm_password": "Confirm Password",
  "contact": "Contact",
  "country": "Country",
  "create": "Create",
  "create_account": "Create Account",
  "create_date": "Create Date",
  "creationdate": "CreationDate",
  "currency": "Currency",
  "customer_success": "Successful registration, please check your email address and complete activation",
  "dead_line": "Dead Line",
  "dealer": "Dealer",
  "dealer_success": "Waiting for approval",
  "description": "Description",
  "domain": "Domain",
  "domain_in_use": "Domain is in use.",
  "email": "Email",
  "email_format_error": "Email format error",
  "email_used": "The mailbox is already in use",
  "enter_character": "Enter the characters in the picture",
  "enter_confirm_password": "Enter new password again",
  "enter_new_password": "Enter new password",
  "enter_old_password": "Enter old password",
  "erp_list": "Subscriptions",
  "erp_status": "Status",
  "expire_date": "Expire date",
  "female": "Female",
  "first_name": "First Name",
  "forget_password": "Forget Password",
  "forgot_password": "Forgot password?",
  "form_not_exist": "The form does not exist",
  "format_error": "Format Error",
  "group_code": "Group Code",
  "group_name": "Group Name",
  "home_company_address": "Home/Company Address",
  "image": "Image",
  "information_success": "The modification of the account information was successful",
  "initial_info": "Initial Info",
  "input_password": "Please enter the password",
  "input_password_again": "Please enter the password again",
  "last_name": "Last Name",
  "legal_person": "Legal Person",
  "male": "Male",
  "modify": "Modify",
  "modify_erp_information": "Modify ERP Information",
  "modules": "Modules",
  "month": "User/Month",
  "name": "Name",
  "new_password": "New Password",
  "new_password_toEmail": "We have sent a new password to your email",
  "next": "Next",
  "noFoundurl": "Instance doesn't exist",
  "not_null": "There are required items that are not filled in",
  "official_website": "Official Website:",
  "ok": "OK",
  "old_password": "Old Password",
  "old_password_error": "Old password doesn't match",
  "one_time_payment": "One Time Payment",
  "operation": "Operation",
  "or": "OR",
  "order": "Order",
  "order-no": "Order-No",
  "order_close": "The order has been closed",
  "order_list": "Order List",
  "order_no": "Order No",
  "order_status": "Order Status",
  "other": "Other",
  "paid": "Paid",
  "password": "Password",
  "password_error": "The password must be composed of 6-20 digits plus letters!",
  "password_error_two": "The two input passwords are inconsistent!",
  "password_least": "The password is at least 6 digits long and contains numbers and letters/special characters",
  "password_strength": "Password Strength",
  "pay": "Purchase",
  "pay_error": "Failed to get payment information",
  "payment": "Checkout Method",
  "payment_date": "Payment Date",
  "personal": "Personal",
  "please_email": "Please check your email",
  "pos": "Pos",
  "previous": "Previous",
  "price": "Price",
  "privacy": "By creating a SOMATIME Account,Understand and agree to SOMATIME's",
  "privacy_notice": "Privacy Notice",
  "product": "Product",
  "product_list": "Product List",
  "product_name": "Product Name",
  "purchase": "Purchase",
  "purchase_success": "Purchase Success",
  "refunded": "Refunded",
  "registered": "This email address has been registered",
  "registered_email_address": "We have registered with your email address",
  "renewal": "Renewal",
  "repeat_password": "Repeat Password",
  "requied": "Requied",
  "requied_num": "Number Only",
  "require_tips": "Buyer Required Information Missing",
  "required": "Required",
  "reseller": "Reseller",
  "resend": "Resend",
  "reset_password": "We have sent an email with password confirmation link to",
  "revoke": "Cancel Order",
  "revoke_tip1": "Do you want to close the current order?",
  "role": "Role",
  "search": "Search",
  "send_update": "Send me updates from SOMATIME",
  "sex": "Sex",
  "signIn": "Sign In",
  "sign_out": "Sign Out",
  "state": "State/Province",
  "status": "Payment Status",
  "status_not_match": "The status does not match",
  "strength_high": "HIgh",
  "strength_low": "Low",
  "strength_mid": "Middle",
  "submit": "Submit",
  "submitted": "Submitted",
  "subscribe": "Subscribe",
  "subscribe-mon": "Subscribe-Mon",
  "subscript_success": "Subscript Success",
  "telephone": "Telephone",
  "tenant_list": "Tenant List",
  "tenant_management_system": "TENANT MANAGEMENT SYSTEM",
  "tenant_system": "TENANT SYSTEM",
  "terms_of_use": "Terms of Use",
  "time_info": "Time Info",
  "title": "Title",
  "unpaid": "Unpaid",
  "update_password_success": "The password was modified successfully",
  "user": "User",
  "user_check": "Please read and check the consent privacy statement and terms of use",
  "user_id": "User Id",
  "user_month": "Month",
  "user_not_active": "User not activated",
  "user_not_exist": "User doesn't exist",
  "user_password_error": "Password incorrect",
  "user_qty": "User Quantity",
  "username": "Username",
  "ver_code_error": "Verification code error",
  "ver_code_exd": "verification code has expired",
  "visit": "Visit",
  "welcome_to_iceq": "WELCOME TO SOMATIME",
  "zip": "Zip",
  "trial": "Trial",
  "requesting_a_trial": "Application successful! You will receive the information of your applied demo within 24 hours.",
  "trial_orders_have_been_requested": "Trial orders have been requested",
  "apply_trial": "Request Demo",
  "request_": "Request",
  "trial_": "Trial",
  "on_trial": "on Trial",
  "order_not_exist": "Order not exist",
  "wait_for_payment": "Wait for Payment",
  "trial_reject": "Demo rejected",
  "tips": "Tips",
  "confirm": "Confirm",
  "cancel": "Cancel",
  "trial_only_allow_one_time_payment_method": "Checkout method can only choose One Time Payment when requesting trial.",
  "domain_info": "Domain Info",
  "please_fill_in_domain_info": "Please fill in the domain information",
  "user_quantity_and_month_required": "User quantity and month required",
  "password_must_be_the_same": "The confirmation password must be the same as the reset password!",
  "enter_the_password_and_new_password": "Please enter the password and new password first!",
  "wrong_user_name_and_password": "Wrong user name and password!",
  "close_the_page_without_saving": "Do you want to close the page without saving confirmation?",
  "cancel_input": "Cancel input",
  "user_does_not_exist": "User does not exist",
  "modify_success": "Modify success",
  "email_has_been_used": "Email has been used!",
  "created_successfully": "Created successfully",
  "error_tip_10098": "Mail delivery failed, please re-request or contact the admin",
};